// My Profile: the pre-sale (email marketing) switch, the name/mobile form and the address form
// save through the garage app's proxy at /apps/garage/account/*, which knows which customer is
// signed in. The garage tile and the cars chip fill in from /apps/garage/vehicles. The
(function () {
  var root = document.getElementById('my-profile');
  if (!root) return;

  var api = root.getAttribute('data-garage-api') || '/apps/garage';

  function post(path, body) {
    return fetch(api + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) {
          var error = new Error((data && data.message) || 'Something went wrong. Please try again.');
          error.code = data && data.error;
          throw error;
        }
        return data;
      });
    });
  }

  function showError(el, message) {
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function hideError(el) {
    if (el) el.hidden = true;
  }

  function carName(vehicle) {
    return vehicle.nickname || [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ');
  }

  function coverPhoto(vehicle) {
    return (vehicle.photos || []).filter(function (photo) { return photo && photo.url; })[0] || null;
  }

  function photoInto(frame, photo, alt) {
    var image = document.createElement('img');
    image.src = photo.url;
    image.alt = alt || '';
    image.loading = 'lazy';
    if (photo.position) image.style.objectPosition = photo.position;
    frame.appendChild(image);
    frame.hidden = false;
  }

  // Pre-sale switch -----------------------------------------------------------------

  var presale = root.querySelector('[data-presale]');
  var toggle = root.querySelector('[data-presale-switch]');
  if (presale && toggle) {
    var status = root.querySelector('[data-presale-status]');
    var label = toggle.querySelector('.my-profile__switch-label');
    var chip = root.querySelector('[data-presale-chip]');
    var presaleError = root.querySelector('[data-presale-error]');

    function render(on) {
      toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      presale.classList.toggle('is-on', on);
      if (label) label.textContent = label.getAttribute(on ? 'data-on' : 'data-off');
      if (status) status.textContent = status.getAttribute(on ? 'data-on' : 'data-off');
      if (chip) {
        chip.textContent = chip.getAttribute(on ? 'data-on' : 'data-off');
        chip.classList.toggle('my-profile__chip--on', on);
      }
    }

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-busy') === 'true') return;
      var wasOn = toggle.getAttribute('aria-checked') === 'true';
      var on = !wasOn;
      hideError(presaleError);
      toggle.setAttribute('aria-busy', 'true');
      render(on);
      post('/account/marketing', { subscribed: on })
        .then(function (data) {
          render(!!data.subscribed);
        })
        .catch(function (error) {
          render(wasOn);
          showError(presaleError, error.message);
        })
        .then(function () {
          toggle.removeAttribute('aria-busy');
        });
    });
  }

  // Name and mobile ------------------------------------------------------------------

  var form = root.querySelector('[data-profile-form]');
  if (form) {
    var save = form.querySelector('[data-profile-save]');
    var saved = form.querySelector('[data-profile-saved]');
    var profileError = form.querySelector('[data-profile-error]');
    var nameEl = root.querySelector('[data-account-name]');
    var original = snapshot();

    function snapshot() {
      return {
        firstName: form.firstName.value.trim(),
        lastName: form.lastName.value.trim(),
        phone: form.phone.value.trim(),
      };
    }

    function changed() {
      var now = snapshot();
      return now.firstName !== original.firstName || now.lastName !== original.lastName || now.phone !== original.phone;
    }

    form.addEventListener('input', function () {
      save.disabled = !changed();
      if (saved) saved.hidden = true;
      hideError(profileError);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (save.disabled) return;
      var body = snapshot();
      save.disabled = true;
      save.setAttribute('aria-busy', 'true');
      hideError(profileError);
      post('/account/profile', body)
        .then(function (data) {
          original = {
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            phone: data.phone || '',
          };
          form.firstName.value = original.firstName;
          form.lastName.value = original.lastName;
          form.phone.value = original.phone;
          var fullName = [original.firstName, original.lastName].filter(Boolean).join(' ');
          if (nameEl && fullName) nameEl.textContent = fullName;
          if (saved) saved.hidden = false;
        })
        .catch(function (error) {
          showError(profileError, error.message);
          save.disabled = false;
        })
        .then(function () {
          save.removeAttribute('aria-busy');
        });
    });
  }

  var editDetails = root.querySelector('[data-edit-details]');
  if (editDetails && form) {
    editDetails.addEventListener('click', function (event) {
      event.preventDefault();
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var first = form.querySelector('input:not([disabled])');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
    });
  }

  // Address --------------------------------------------------------------------------

  var addressCard = root.querySelector('[data-address]');
  var addressForm = addressCard && addressCard.querySelector('[data-address-form]');
  if (addressCard && addressForm) {
    var addressView = addressCard.querySelector('[data-address-view]');
    var addressText = addressCard.querySelector('[data-address-text]');
    var addressEmpty = addressCard.querySelector('[data-address-empty]');
    var addressEdit = addressCard.querySelector('[data-address-edit]');
    var addressSaved = addressCard.querySelector('[data-address-saved]');
    var addressSave = addressForm.querySelector('[data-address-save]');
    var addressCancel = addressForm.querySelector('[data-address-cancel]');
    var addressError = addressForm.querySelector('[data-address-error]');
    var countrySelect = addressForm.querySelector('[data-country-select]');
    var provinceField = addressForm.querySelector('[data-province-field]');
    var provinceSelect = addressForm.querySelector('[data-province-select]');
    var provincesTemplate = addressForm.querySelector('[data-country-provinces]');

    // Shopify's country list carries each country's states as JSON on the option.
    var provincesByCountry = {};
    if (provincesTemplate) {
      var holder = document.createElement('select');
      holder.innerHTML = provincesTemplate.innerHTML;
      Array.prototype.forEach.call(holder.options, function (option) {
        try {
          provincesByCountry[option.value] = JSON.parse(option.getAttribute('data-provinces') || '[]');
        } catch (e) {
          provincesByCountry[option.value] = [];
        }
      });
    }

    function fillProvinces(keep) {
      var chosen = countrySelect.options[countrySelect.selectedIndex];
      var name = chosen ? chosen.getAttribute('data-name') || chosen.textContent : '';
      var provinces = provincesByCountry[name] || [];
      var current = keep ? provinceSelect.getAttribute('data-current') || '' : '';
      provinceSelect.innerHTML = '';
      if (!provinces.length) {
        provinceField.hidden = true;
        return;
      }
      provinces.forEach(function (pair) {
        var option = document.createElement('option');
        option.value = pair[1];
        option.textContent = pair[0];
        if (pair[1] === current || pair[0] === current) option.selected = true;
        provinceSelect.appendChild(option);
      });
      provinceField.hidden = false;
    }

    fillProvinces(true);
    countrySelect.addEventListener('change', function () { fillProvinces(false); });

    function openAddress() {
      addressView.hidden = true;
      addressForm.hidden = false;
      hideError(addressError);
      var first = addressForm.querySelector('input');
      if (first) first.focus();
    }

    function closeAddress() {
      addressForm.hidden = true;
      addressView.hidden = false;
    }

    addressEdit.addEventListener('click', openAddress);
    addressCancel.addEventListener('click', closeAddress);

    addressForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (addressSave.getAttribute('aria-busy') === 'true') return;
      var body = {
        firstName: addressForm.firstName.value.trim(),
        lastName: addressForm.lastName.value.trim(),
        address1: addressForm.address1.value.trim(),
        address2: addressForm.address2.value.trim(),
        city: addressForm.city.value.trim(),
        zip: addressForm.zip.value.trim(),
        provinceCode: provinceField.hidden ? '' : provinceSelect.value,
        countryCode: countrySelect.value,
      };
      if (!body.address1 || !body.city || !body.zip) {
        showError(addressError, 'Enter your street address, suburb and postcode.');
        return;
      }
      hideError(addressError);
      addressSave.setAttribute('aria-busy', 'true');
      addressSave.disabled = true;
      post('/account/address', body)
        .then(function (data) {
          var lines = (data && data.formatted) || [];
          addressText.innerHTML = '';
          lines.forEach(function (line, index) {
            if (index) addressText.appendChild(document.createElement('br'));
            addressText.appendChild(document.createTextNode(line));
          });
          addressText.hidden = lines.length === 0;
          if (addressEmpty) addressEmpty.hidden = lines.length > 0;
          addressEdit.textContent = lines.length ? 'Edit address' : 'Add address';
          provinceSelect.setAttribute('data-current', body.provinceCode);
          if (addressSaved) addressSaved.hidden = false;
          closeAddress();
        })
        .catch(function (error) {
          showError(addressError, error.message);
        })
        .then(function () {
          addressSave.removeAttribute('aria-busy');
          addressSave.disabled = false;
        });
    });
  }

  // Public profile --------------------------------------------------------------------
  // The driver's page at /pages/drivers/<handle>: name, handle, bio, socials and photos, with
  // a public/private switch. Private profiles are drafts Shopify never serves.

  var pub = root.querySelector('[data-public]');
  if (pub) {
    var $ = function (name) { return pub.querySelector('[data-public-' + name + ']'); };
    var pubForm = $('form');
    var pubSave = $('save');
    var pubSaved = $('saved');
    var pubError = $('error');
    var pubSwitch = $('switch');
    var pubSwitchLabel = pubSwitch.querySelector('.my-profile__switch-label');
    var pubStatus = $('status');
    var pubLink = $('link');
    var pubUrl = $('url');
    var pubView = $('view');
    var pubCopy = $('copy');
    var handleInput = pubForm.elements.handle;
    var handleHint = $('handle-hint');
    var handleDefaultHint = handleHint.textContent;
    var bioCounter = $('counter');
    var photoHint = $('photo-hint');
    var photoError = $('photo-error');
    var base = root.getAttribute('data-profile-base') || 'kots.au/pages/drivers/';
    var profile = null;
    var original = null;
    var busy = false;

    function slug(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9-\s]/g, '')
        .trim()
        .replace(/[\s-]+/g, '-')
        .slice(0, 30);
    }

    function snapshot() {
      var out = {};
      ['displayName', 'homeTown', 'handle', 'bio', 'instagram', 'tiktok', 'youtube', 'facebook'].forEach(function (name) {
        out[name] = pubForm.elements[name].value.trim();
      });
      out.handle = slug(out.handle);
      return out;
    }

    function changed() {
      if (!original) return true;
      var now = snapshot();
      return Object.keys(now).some(function (key) { return now[key] !== original[key]; });
    }

    function fill(data) {
      ['displayName', 'homeTown', 'handle', 'bio', 'instagram', 'tiktok', 'youtube', 'facebook'].forEach(function (name) {
        pubForm.elements[name].value = data[name] || '';
      });
      original = snapshot();
      pubSave.disabled = true;
      updateCounter();
      preview();
    }

    function updateCounter() {
      if (bioCounter) bioCounter.textContent = pubForm.elements.bio.value.length + '/300';
    }

    // The card on the left shows the profile as the page will.
    function preview() {
      var name = pubForm.elements.displayName.value.trim() || root.getAttribute('data-first-name') || 'Your name';
      $('name').textContent = name;
      var town = pubForm.elements.homeTown.value.trim();
      $('town').textContent = town;
      $('town').hidden = !town;
      $('initials').textContent = name.slice(0, 1).toUpperCase();
    }

    function renderPhotos() {
      var avatarImg = $('avatar-img');
      var bannerImg = $('banner-img');
      var hasProfile = !!profile;
      var avatar = hasProfile && profile.avatarUrl;
      var banner = hasProfile && profile.bannerUrl;

      avatarImg.hidden = !avatar;
      if (avatar) avatarImg.src = profile.avatarUrl;
      $('initials').hidden = !!avatar;
      $('avatar-label').textContent = $('avatar-label').getAttribute(avatar ? 'data-change' : 'data-add');
      $('avatar-clear').hidden = !avatar;
      $('avatar-adjust').hidden = !avatar;

      bannerImg.hidden = !banner;
      if (banner) {
        bannerImg.src = profile.bannerUrl;
        bannerFocus = parseFocus(profile.bannerPosition);
        bannerImg.style.objectPosition = bannerFocus.x + '% ' + bannerFocus.y + '%';
      }
      $('banner').classList.toggle('has-banner', !!banner);
      $('banner').tabIndex = banner ? 0 : -1;
      $('banner-empty').hidden = !!banner;
      $('banner-focus').hidden = !banner;
      $('banner-label').textContent = $('banner-label').getAttribute(banner ? 'data-change' : 'data-add');
      $('banner-clear').hidden = !banner;

      $('avatar-input').disabled = !hasProfile;
      $('banner-input').disabled = !hasProfile;
      photoHint.hidden = hasProfile;
    }

    function renderVisibility() {
      var on = !!(profile && profile.public);
      pubSwitch.disabled = !profile || busy;
      pubSwitch.setAttribute('aria-checked', on ? 'true' : 'false');
      pubSwitchLabel.textContent = pubSwitchLabel.getAttribute(on ? 'data-on' : 'data-off');
      pubStatus.textContent = pubStatus.getAttribute(!profile ? 'data-new' : on ? 'data-on' : 'data-off');
      pubLink.hidden = !on;
      if (profile) {
        var href = profile.url;
        pubUrl.textContent = base + profile.handle;
        pubUrl.href = href;
        pubView.href = href;
      }
    }

    function apply(data) {
      profile = data.profile;
      if (profile) fill(profile);
      renderPhotos();
      renderVisibility();
    }

    function setBusy(state) {
      busy = state;
      pubSave.disabled = state || !changed();
      pubSave.textContent = pubSave.getAttribute(state ? 'data-busy' : 'data-label');
      pubSwitch.disabled = state || !profile;
      pubSwitch.setAttribute('aria-busy', state ? 'true' : 'false');
      pub.classList.toggle('is-busy', state);
    }

    function load() {
      $('loading').hidden = false;
      $('failed').hidden = true;
      $('ready').hidden = true;
      fetch(api + '/profile', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('profile ' + response.status);
          return response.json();
        })
        .then(function (data) {
          if (data.profile) {
            apply(data);
          } else {
            // A new profile starts from the account name; nothing is saved until they choose to.
            profile = null;
            var first = root.getAttribute('data-first-name') || '';
            var last = root.getAttribute('data-last-name') || '';
            fill({ displayName: (first + ' ' + last).trim(), handle: slug(first + ' ' + last.slice(0, 1)) });
            original = null;
            pubSave.disabled = !snapshot().displayName || !snapshot().handle;
            renderPhotos();
            renderVisibility();
          }
          $('loading').hidden = true;
          $('ready').hidden = false;
        })
        .catch(function () {
          $('loading').hidden = true;
          $('failed').hidden = false;
        });
    }
    $('retry').addEventListener('click', load);

    // Typing: live preview, bio counter, handle check.
    var handleTimer = null;
    pubForm.addEventListener('input', function (event) {
      pubSave.disabled = busy || !changed() || !snapshot().displayName || !snapshot().handle;
      pubSaved.hidden = true;
      hideError(pubError);
      updateCounter();
      preview();
      if (event.target === handleInput) {
        var typed = handleInput.value;
        var cleaned = typed.toLowerCase().replace(/[^a-z0-9-\s]/g, '').replace(/\s/g, '-');
        if (cleaned !== typed) handleInput.value = cleaned;
        clearTimeout(handleTimer);
        handleTimer = setTimeout(checkHandle, 400);
      }
    });
    handleInput.addEventListener('blur', function () {
      handleInput.value = slug(handleInput.value);
    });

    function checkHandle() {
      var handle = slug(handleInput.value);
      handleHint.classList.remove('is-ok', 'is-bad');
      if (!handle) {
        handleHint.textContent = handleDefaultHint;
        return;
      }
      if (profile && handle === profile.handle) {
        handleHint.textContent = base + handle + ' is yours.';
        handleHint.classList.add('is-ok');
        return;
      }
      fetch(api + '/profile/handle?h=' + encodeURIComponent(handle), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (slug(handleInput.value) !== data.handle) return;
          handleHint.textContent = data.available ? base + data.handle + ' is free.' : data.message;
          handleHint.classList.add(data.available ? 'is-ok' : 'is-bad');
        })
        .catch(function () {
          handleHint.textContent = handleDefaultHint;
        });
    }

    function saveProfile(extra) {
      var body = snapshot();
      if (extra) Object.keys(extra).forEach(function (key) { body[key] = extra[key]; });
      setBusy(true);
      hideError(pubError);
      hideError($('switch-error'));
      return post('/profile', body)
        .then(function (data) {
          apply(data);
          return data;
        })
        .then(function (data) { setBusy(false); return data; }, function (error) { setBusy(false); throw error; });
    }

    pubForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (pubSave.disabled) return;
      saveProfile()
        .then(function () {
          pubSaved.hidden = false;
          handleHint.textContent = base + profile.handle + ' is yours.';
          handleHint.classList.remove('is-bad');
          handleHint.classList.add('is-ok');
        })
        .catch(function (error) {
          showError(pubError, error.message);
          if (error.code === 'handle_taken' || error.code === 'invalid_handle') handleInput.focus();
        });
    });

    pubSwitch.addEventListener('click', function () {
      if (pubSwitch.disabled || !profile) return;
      var on = pubSwitch.getAttribute('aria-checked') !== 'true';
      saveProfile({ public: on })
        .then(function () {
          pubSaved.hidden = true;
        })
        .catch(function (error) {
          showError($('switch-error'), error.message);
        });
    });

    pubCopy.addEventListener('click', function () {
      var text = pubUrl.href;
      var done = function () {
        pubCopy.textContent = pubCopy.getAttribute('data-copied');
        setTimeout(function () { pubCopy.textContent = pubCopy.getAttribute('data-label'); }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { window.prompt('Copy your link', text); });
      } else {
        window.prompt('Copy your link', text);
      }
    });

    // Photos: shrunk in the browser, sent one at a time like garage photos.
    function shrink(file, maxSize) {
      return new Promise(function (resolve, reject) {
        var image = new Image();
        var url = URL.createObjectURL(file);
        image.onload = function () {
          URL.revokeObjectURL(url);
          var scale = Math.min(1, maxSize / Math.max(image.width, image.height));
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(image.width * scale);
          canvas.height = Math.round(image.height * scale);
          canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL('image/jpeg', 0.82));
        };
        image.onerror = function () {
          URL.revokeObjectURL(url);
          reject(new Error("That photo couldn't be read. Try a JPG or PNG."));
        };
        image.src = url;
      });
    }

    function sendPhoto(body) {
      setBusy(true);
      hideError(photoError);
      return post('/profile/photo', body)
        .then(function (data) {
          apply(data);
          setBusy(false);
        })
        .catch(function (error) {
          setBusy(false);
          showError(photoError, error.message);
        });
    }

    function onPhotoChosen(kind, maxSize) {
      return function (event) {
        var file = event.target.files && event.target.files[0];
        event.target.value = '';
        if (!file || !profile) return;
        hideError(photoError);
        shrink(file, maxSize)
          .then(function (dataUrl) {
            return sendPhoto({ kind: kind, photo: dataUrl, position: kind === 'banner' ? focusText() : '' });
          })
          .catch(function (error) {
            showError(photoError, error.message);
          });
      };
    }

    $('avatar-input').addEventListener('change', function (event) {
      var file = event.target.files && event.target.files[0];
      event.target.value = '';
      if (!file || !profile) return;
      hideError(photoError);
      openCrop(URL.createObjectURL(file), false);
    });
    $('avatar-adjust').addEventListener('click', function () {
      if (profile && profile.avatarUrl) openCrop(profile.avatarUrl, true);
    });
    $('banner-input').addEventListener('change', onPhotoChosen('banner', 1800));
    $('avatar-clear').addEventListener('click', function () { sendPhoto({ kind: 'avatar', photo: '' }); });
    $('banner-clear').addEventListener('click', function () { sendPhoto({ kind: 'banner', photo: '' }); });
    // Banner position: the banner is dragged, or nudged with the arrow keys, to choose the part shown,
    // the same control as a car's photo in My Garage. Kept as "x y" percentages, saved when the drag ends.
    var bannerFocus = { x: 50, y: 50 };
    var bannerDrag = null;
    var bannerSaveTimer = null;

    function parseFocus(text) {
      var parts = (text || '50 50').split(' ');
      return { x: Number(parts[0]) || 0, y: Number(parts[1]) || 0 };
    }

    function focusText() {
      return bannerFocus.x + ' ' + bannerFocus.y;
    }

    function setBannerFocus(x, y) {
      var clamp = function (value) { return Math.min(100, Math.max(0, Math.round(value))); };
      bannerFocus = { x: clamp(x), y: clamp(y) };
      $('banner-img').style.objectPosition = bannerFocus.x + '% ' + bannerFocus.y + '%';
    }

    function saveBannerFocus() {
      clearTimeout(bannerSaveTimer);
      if (!profile || !profile.bannerUrl || focusText() === (profile.bannerPosition || '50 50')) return;
      sendPhoto({ kind: 'banner', position: focusText() });
    }

    // How far the banner overhangs its frame on each axis once it is scaled to cover it.
    function bannerOverhang() {
      var frame = $('banner').getBoundingClientRect();
      var image = $('banner-img');
      if (!image.naturalWidth || !image.naturalHeight) return { x: 0, y: 0 };
      var scale = Math.max(frame.width / image.naturalWidth, frame.height / image.naturalHeight);
      return { x: image.naturalWidth * scale - frame.width, y: image.naturalHeight * scale - frame.height };
    }

    $('banner').addEventListener('pointerdown', function (event) {
      if (!profile || !profile.bannerUrl || busy) return;
      if (event.target.closest('button, label, input, a')) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      $('banner').setPointerCapture(event.pointerId);
      $('banner').classList.add('is-dragging');
      bannerDrag = { pointer: event.pointerId, x: event.clientX, y: event.clientY, start: bannerFocus, overhang: bannerOverhang() };
    });

    // Dragging the banner right reveals more of its left side, so the position moves the other way.
    $('banner').addEventListener('pointermove', function (event) {
      if (!bannerDrag || bannerDrag.pointer !== event.pointerId) return;
      var moved = function (distance, room) { return room >= 1 ? (distance / room) * 100 : 0; };
      setBannerFocus(
        bannerDrag.start.x - moved(event.clientX - bannerDrag.x, bannerDrag.overhang.x),
        bannerDrag.start.y - moved(event.clientY - bannerDrag.y, bannerDrag.overhang.y)
      );
    });

    function onBannerDragEnd(event) {
      if (!bannerDrag || bannerDrag.pointer !== event.pointerId) return;
      bannerDrag = null;
      $('banner').classList.remove('is-dragging');
      saveBannerFocus();
    }
    $('banner').addEventListener('pointerup', onBannerDragEnd);
    $('banner').addEventListener('pointercancel', onBannerDragEnd);

    $('banner').addEventListener('keydown', function (event) {
      if (event.target !== $('banner') || !profile || !profile.bannerUrl) return;
      var step = { ArrowLeft: [-5, 0], ArrowRight: [5, 0], ArrowUp: [0, -5], ArrowDown: [0, 5] }[event.key];
      if (!step) return;
      event.preventDefault();
      setBannerFocus(bannerFocus.x + step[0], bannerFocus.y + step[1]);
      clearTimeout(bannerSaveTimer);
      bannerSaveTimer = setTimeout(saveBannerFocus, 700);
    });

    // Profile photo crop: the picture is moved and zoomed behind a circle, then the square inside the
    // circle is drawn to a canvas and uploaded. State is the zoom and the image point (as fractions of
    // its size) under the centre of the frame, so a window resize keeps the same framing.
    var crop = $('crop');
    var cropFrame = $('crop-frame');
    var cropImg = $('crop-img');
    var cropZoom = $('crop-zoom');
    var cropError = $('crop-error');
    var cropState = null;
    var cropPointers = {};
    var cropPinch = null;
    var CROP_SIZE = 640;
    var ZOOM_MIN = 1;
    var ZOOM_MAX = 3;

    function cropLayout() {
      if (!cropState) return;
      var size = cropFrame.clientWidth;
      var w = cropImg.naturalWidth;
      var h = cropImg.naturalHeight;
      var scale = (size / Math.min(w, h)) * cropState.zoom;
      var dw = w * scale;
      var dh = h * scale;
      // The frame must stay covered, so the centre point can't get closer to an edge than half a frame.
      cropState.cx = Math.min(1 - size / (2 * dw), Math.max(size / (2 * dw), cropState.cx));
      cropState.cy = Math.min(1 - size / (2 * dh), Math.max(size / (2 * dh), cropState.cy));
      cropImg.style.width = dw + 'px';
      cropImg.style.height = dh + 'px';
      cropImg.style.transform = 'translate(' + (size / 2 - cropState.cx * dw) + 'px, ' + (size / 2 - cropState.cy * dh) + 'px)';
    }

    function setCropZoom(zoom) {
      if (!cropState) return;
      cropState.zoom = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, zoom));
      cropZoom.value = cropState.zoom;
      cropLayout();
    }

    function openCrop(src, remote) {
      hideError(cropError);
      cropState = null;
      cropImg.removeAttribute('src');
      // The CDN allows cross-origin reads, which drawing the current photo to a canvas needs.
      if (remote) cropImg.crossOrigin = 'anonymous';
      else cropImg.removeAttribute('crossorigin');
      cropImg.onload = function () {
        if (!remote) URL.revokeObjectURL(src);
        cropState = { zoom: 1, cx: 0.5, cy: 0.5 };
        cropZoom.value = 1;
        cropLayout();
      };
      cropImg.onerror = function () {
        if (!remote) URL.revokeObjectURL(src);
        showError(cropError, remote ? "Your photo couldn't be loaded. Choose it again to adjust it." : "That photo couldn't be read. Try a JPG or PNG.");
      };
      cropImg.src = src;
      if (!crop.open) crop.showModal();
      cropFrame.focus();
    }

    function closeCrop() {
      if (crop.open) crop.close();
      cropState = null;
      cropPointers = {};
      cropPinch = null;
      cropImg.removeAttribute('src');
    }

    function cropToDataUrl() {
      var size = cropFrame.clientWidth;
      var w = cropImg.naturalWidth;
      var h = cropImg.naturalHeight;
      var scale = (size / Math.min(w, h)) * cropState.zoom;
      var sw = size / scale;
      var canvas = document.createElement('canvas');
      canvas.width = CROP_SIZE;
      canvas.height = CROP_SIZE;
      canvas.getContext('2d').drawImage(cropImg, cropState.cx * w - sw / 2, cropState.cy * h - sw / 2, sw, sw, 0, 0, CROP_SIZE, CROP_SIZE);
      return canvas.toDataURL('image/jpeg', 0.86);
    }

    cropFrame.addEventListener('pointerdown', function (event) {
      if (!cropState) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      cropFrame.setPointerCapture(event.pointerId);
      cropPointers[event.pointerId] = { x: event.clientX, y: event.clientY };
      cropFrame.classList.add('is-dragging');
      var ids = Object.keys(cropPointers);
      if (ids.length === 2) {
        var a = cropPointers[ids[0]];
        var b = cropPointers[ids[1]];
        cropPinch = { distance: Math.hypot(a.x - b.x, a.y - b.y), zoom: cropState.zoom };
      }
    });

    cropFrame.addEventListener('pointermove', function (event) {
      var last = cropPointers[event.pointerId];
      if (!last || !cropState) return;
      var ids = Object.keys(cropPointers);
      if (ids.length >= 2 && cropPinch) {
        cropPointers[event.pointerId] = { x: event.clientX, y: event.clientY };
        var a = cropPointers[ids[0]];
        var b = cropPointers[ids[1]];
        setCropZoom(cropPinch.zoom * (Math.hypot(a.x - b.x, a.y - b.y) / cropPinch.distance));
        return;
      }
      // Dragging moves the picture with the pointer, so the centre point moves the other way.
      cropState.cx -= (event.clientX - last.x) / cropImg.offsetWidth;
      cropState.cy -= (event.clientY - last.y) / cropImg.offsetHeight;
      cropPointers[event.pointerId] = { x: event.clientX, y: event.clientY };
      cropLayout();
    });

    function onCropPointerEnd(event) {
      delete cropPointers[event.pointerId];
      cropPinch = null;
      if (!Object.keys(cropPointers).length) cropFrame.classList.remove('is-dragging');
    }
    cropFrame.addEventListener('pointerup', onCropPointerEnd);
    cropFrame.addEventListener('pointercancel', onCropPointerEnd);

    cropFrame.addEventListener('wheel', function (event) {
      if (!cropState) return;
      event.preventDefault();
      setCropZoom(cropState.zoom - event.deltaY * 0.002);
    }, { passive: false });

    cropFrame.addEventListener('keydown', function (event) {
      if (!cropState) return;
      var nudge = 10;
      var step = { ArrowLeft: [-nudge, 0], ArrowRight: [nudge, 0], ArrowUp: [0, -nudge], ArrowDown: [0, nudge] }[event.key];
      if (step) {
        event.preventDefault();
        cropState.cx -= step[0] / cropImg.offsetWidth;
        cropState.cy -= step[1] / cropImg.offsetHeight;
        cropLayout();
      } else if (event.key === '+' || event.key === '=') {
        event.preventDefault();
        setCropZoom(cropState.zoom + 0.1);
      } else if (event.key === '-' || event.key === '_') {
        event.preventDefault();
        setCropZoom(cropState.zoom - 0.1);
      }
    });

    cropZoom.addEventListener('input', function () {
      setCropZoom(Number(cropZoom.value));
    });

    window.addEventListener('resize', function () {
      if (crop.open) cropLayout();
    });

    $('crop-cancel').addEventListener('click', closeCrop);
    crop.addEventListener('cancel', function (event) {
      event.preventDefault();
      if (!busy) closeCrop();
    });

    $('crop-save').addEventListener('click', function () {
      if (!cropState || busy) return;
      var dataUrl;
      try {
        dataUrl = cropToDataUrl();
      } catch (error) {
        showError(cropError, "Your photo couldn't be read. Choose it again to adjust it.");
        return;
      }
      var button = $('crop-save');
      hideError(cropError);
      setBusy(true);
      button.disabled = true;
      button.textContent = button.getAttribute('data-busy');
      post('/profile/photo', { kind: 'avatar', photo: dataUrl })
        .then(function (data) {
          apply(data);
          closeCrop();
        })
        .catch(function (error) {
          showError(cropError, error.message);
        })
        .then(function () {
          setBusy(false);
          button.disabled = false;
          button.textContent = button.getAttribute('data-label');
        });
    });

    load();
  }

  // Garage: hero picture, cars chip and garage card ------------------------------------

  var garageTile = root.querySelector('[data-garage-tile]');
  var garageChip = root.querySelector('[data-garage-chip]');
  if (garageTile || garageChip) {
    fetch(api + '/vehicles', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('garage ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var vehicles = (data && data.vehicles) || [];
        var withPhoto = vehicles.filter(function (vehicle) { return coverPhoto(vehicle); });
        var names = vehicles.map(carName).filter(Boolean);

        if (garageChip) {
          garageChip.querySelector('[data-garage-count]').textContent = String(vehicles.length);
          garageChip.querySelector('[data-garage-noun]').textContent = vehicles.length === 1 ? 'car' : 'cars';
          garageChip.hidden = false;
        }

        if (!garageTile) return;
        var title = garageTile.querySelector('[data-garage-title]');
        var plates = garageTile.querySelector('[data-garage-plates]');
        var copy = garageTile.querySelector('[data-garage-copy]');
        var link = garageTile.querySelector('[data-garage-link]');
        var art = garageTile.querySelector('[data-garage-art]');
        var placeholder = garageTile.querySelector('[data-garage-placeholder]');

        if (vehicles.length === 0) return;

        var feature = withPhoto[0] || vehicles[0];
        var featurePhoto = coverPhoto(feature);
        var others = vehicles.filter(function (vehicle) { return vehicle !== feature; }).map(carName).filter(Boolean);
        var missing = vehicles.length - withPhoto.length;

        var modelName = [feature.year, feature.make, feature.model].filter(Boolean).join(' ');
        if (title) title.textContent = modelName || feature.nickname || 'Your car';
        if (plates) {
          plates.innerHTML = '';
          var nick = feature.nickname && String(feature.nickname).trim();
          if (nick && modelName && nick.toUpperCase() !== String(feature.rego || '').toUpperCase()) {
            var nickPlate = document.createElement('li');
            nickPlate.textContent = '“' + nick + '”';
            plates.appendChild(nickPlate);
          }
          if (feature.rego) {
            var rego = document.createElement('li');
            rego.textContent = String(feature.rego).toUpperCase();
            plates.appendChild(rego);
          }
          if (feature.colour) {
            var colour = document.createElement('li');
            colour.textContent = feature.colour;
            plates.appendChild(colour);
          }
          // "AWD · Manual · RB26 · Twin turbo · E85 · 6 cyl · 2000hp" as one plate, so the tile stays short.
          var cylinders = feature.cylinders ? (/^\d+$/.test(feature.cylinders) ? feature.cylinders + ' cyl' : feature.cylinders) : '';
          var engine = [feature.drivetrain, feature.transmission, feature.engineCode, feature.induction, feature.fuel, cylinders, feature.power]
            .filter(Boolean).join(' · ');
          if (engine) {
            var enginePlate = document.createElement('li');
            enginePlate.textContent = engine;
            plates.appendChild(enginePlate);
          }
          if (feature.speedClass) {
            var cls = document.createElement('li');
            cls.className = 'is-class';
            cls.textContent = 'Class: ' + feature.speedClass;
            plates.appendChild(cls);
          }
          plates.hidden = plates.children.length === 0;
        }
        if (copy) {
          var parts = [];
          if (others.length) parts.push('Also in the garage: ' + others.slice(0, 3).join(', ') + (others.length > 3 ? ' and ' + (others.length - 3) + ' more' : '') + '.');
          if (missing > 0) parts.push('<strong>' + (missing === 1 ? '1 car has no photo yet.' : missing + ' cars have no photo yet.') + '</strong> Add one so the crew can find you on the night.');
          if (!parts.length) parts.push('Photos, rego and class, ready when you enter an event.');
          copy.innerHTML = parts.join(' ');
        }
        if (link) link.textContent = 'Open garage';
        if (featurePhoto && art) {
          photoInto(art, featurePhoto, carName(feature));
          if (placeholder) placeholder.remove();
        }
      })
      .catch(function () {
        // Garage unavailable: the page still shows everything that came from the order history.
      });
  }
})();
